module.exports = __webpack_public_path__ + "static/media/loading.b3115555.gif";